var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnMaliciousProtection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-malicious-protection",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(9.236 5.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(0 13.653)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(13.539 51.341)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(4.832)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(0 27.552)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(30.922)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(18.824 63.153)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(27.398 31.535)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icn",
    transform: "translate(18.733 21.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18989",
    "data-name": "Group 18989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25502",
    "data-name": "Path 25502",
    d: "M4.435,6.413c2.145-.128,6.922-.784,10.155-3.256a1.267,1.267,0,0,1,1.418,0c1.848,1.037,6.514,3.5,9.519,3.76A1.393,1.393,0,0,1,26.8,8.265c.143,4-.419,15.739-11.044,23.048a1.339,1.339,0,0,1-1.486.031A24.64,24.64,0,0,1,3.16,7.653,1.377,1.377,0,0,1,4.435,6.413Z",
    transform: "translate(6.161 9.245)",
    fill: "none",
    stroke: "#2fa2d9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25497",
    "data-name": "Path 25497",
    d: "M101.282,88.032a1.179,1.179,0,0,0-1.179,1.179v8.253a1.179,1.179,0,1,0,2.358,0V89.211a1.179,1.179,0,0,0-1.179-1.179",
    transform: "translate(-80.307 -70.623)",
    fill: "#2fa2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25498",
    "data-name": "Path 25498",
    d: "M101.282,153.615a1.179,1.179,0,0,0-1.179,1.179v1.179a1.179,1.179,0,0,0,2.358,0v-1.179a1.179,1.179,0,0,0-1.179-1.179",
    transform: "translate(-80.307 -123.237)",
    fill: "#2fa2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25499",
    "data-name": "Path 25499",
    d: "M38.757,7.286H3.269c-.026.377-.068.7-.068,1.019,0,7.742.014,15.485-.02,23.227,0,.973.321,1.273,1.256,1.212A24.646,24.646,0,0,1,7.7,32.75a1.346,1.346,0,0,1,.917.614c.429.768.738,1.6,1.161,2.564H5.727c-.824,0-1.647,0-2.471-.006A3.025,3.025,0,0,1,.006,32.645Q0,19.054,0,5.464C0,4.8,0,4.146,0,3.487.02,1.152,1.2,0,3.555,0q9.933.006,19.867.01,7.512,0,15.024,0c2.611,0,3.7,1.117,3.7,3.735q-.026,14.283-.044,28.565c0,2.581-1.191,3.736-3.76,3.711C36.4,36,34.453,36.016,32.51,36.01c-.252,0-.5-.033-.794-.053.457-.981.848-1.921,1.337-2.806a1.143,1.143,0,0,1,.851-.408c1.349-.043,2.7-.027,4.052-.017.591,0,.884-.176.882-.855Q38.8,19.861,38.813,7.852c0-.16-.031-.32-.056-.566M11.629,5.26V5.247c1.084,0,2.173.053,3.253-.016A1.461,1.461,0,0,0,16.4,3.751c-.079-.971-.76-1.236-1.589-1.243-2.038-.016-4.077-.023-6.116,0-1.069.011-1.568.469-1.579,1.346-.011.849.521,1.36,1.55,1.4.985.037,1.972.008,2.959.008M5.95,3.725A1.478,1.478,0,0,0,4.427,2.354,1.5,1.5,0,0,0,2.965,3.8,1.546,1.546,0,0,0,4.551,5.246a1.553,1.553,0,0,0,1.4-1.521",
    transform: "translate(0 -0.001)",
    fill: "#007dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25500",
    "data-name": "Path 25500",
    d: "M40.508,15.373c-.986,0-1.974.029-2.959-.008-1.029-.038-1.561-.549-1.55-1.4.011-.877.51-1.335,1.579-1.346,2.038-.021,4.077-.014,6.116,0,.829.006,1.51.272,1.589,1.243a1.461,1.461,0,0,1-1.522,1.48c-1.08.069-2.168.016-3.253.016v.012",
    transform: "translate(-28.88 -10.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25501",
    "data-name": "Path 25501",
    d: "M17.977,13.27a1.493,1.493,0,0,1-2.985.08A1.5,1.5,0,0,1,16.453,11.9a1.478,1.478,0,0,1,1.524,1.371",
    transform: "translate(-12.027 -9.546)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMaliciousProtection);
export default __webpack_public_path__ + "static/media/icn-malicious-protection.1816e880104c4604cd6cb992d98ddd3e.svg";
export { ForwardRef as ReactComponent };